import { combineReducers } from 'redux';

import {
  LOAD_AUDIENCE_TIMELINE,
  UNLOAD_CURRENT_ARTIST,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const timeline = combineReducers({
  data(state = null, action) {
    switch (action.type) {
      case UNLOAD_CURRENT_ARTIST:
        return null;
      case LOAD_AUDIENCE_TIMELINE:
        return loadReducer(state, action);
      default:
        return state;
    }
  },

  query(state = null, action) {
    switch (action.type) {
      case UNLOAD_CURRENT_ARTIST:
        return null;
      case LOAD_AUDIENCE_TIMELINE: {
        if (action.meta.request) return action.meta.query;
        return state;
      }
      default:
        return state;
    }
  },
});
